export const NOMINATE = 'NOMINATE';